module.exports = __webpack_public_path__ + "img/game_tiyu_tennis.9003e8ac.png";